import { jsx } from "panel";
import { RadioButtonEl } from "common/components/radio-button";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".outer-container",
    class: { selected: this.attr(`selected`) }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".radio-container"
  }, /* @__PURE__ */ jsx(RadioButtonEl, {
    disabled: this.attr(`disabled`),
    focused: this.attr(`focused`),
    selected: this.attr(`selected`),
    theme: this.attr(`theme`)
  }), /* @__PURE__ */ jsx("slot", {
    sel: ".button-title",
    attrs: { name: `label-title` }
  })), /* @__PURE__ */ jsx("slot", {
    attrs: { name: `label-text` }
  }));
}
